import { MissionCardProps } from '@web/pages/mission/components/MissionCard/MissionCard'
import { MissionGroupType } from '@web/types/graphql'

const MEDIA_REVIEW_MISSION_GROUP_TYPE = [
  MissionGroupType.PhotoReview,
  MissionGroupType.NatureCategoryReview,
  MissionGroupType.VideoReview,
]

export const isMediaReviewMissionGroup = (missionCard: MissionCardProps) => {
  return MEDIA_REVIEW_MISSION_GROUP_TYPE.includes(missionCard.missionGroupType)
}
